import { Typography } from 'seagull/components/Typography';
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { Grid } from 'seagull';
import { templateTypeToDropdownLabel, useEditIntroMessage } from "../../../../components/AgreementStudio/IntroMessage/IntroMessage.utils";
import IntroMessage from "../../../../components/AgreementStudio/IntroMessage/IntroMessage";
import { jsx as _jsx } from "react/jsx-runtime";
export default function IntroductoryMessageCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const {
    getTemplateTypeByMessage
  } = useEditIntroMessage();
  const onClick = () => onOpenModal({
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Introductory message',
        testid: 'edit-introductory-message-modal',
        content: /*#__PURE__*/_jsx(Grid, {
          rowGap: "small",
          children: /*#__PURE__*/_jsx(IntroMessage, {
            inputWidth: "380px",
            initialTemplateContent: draft.customNotificationText(),
            onMessageChange: message => setDraft(draft.setCustomNotificationText(message))
          })
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-introductory-message-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "introductory-message-".concat(index),
      children: templateTypeToDropdownLabel[getTemplateTypeByMessage(draft.customNotificationText())]
    })
  });
}